const estateDef = {
    estates: [],
    filteredEstates: [],
    isLoading: true,
    error: false
}
function estateState(state = estateDef, action) {
    switch (action.type) {
        case "ESTATE_FETCH_ERROR": {
            return {
                ...state,
                error: true,
                isLoading: false
            }
        }
        case "ESTATE_FETCH_SUCCESS": {
            return {
                ...state,
                estates: action.payload,
                filteredEstates: action.payload,
                isLoading: false
            }
        }
        case "ESTATE_FILTER": {
            return {
                ...state,
                filteredEstates: action.payload
            }
        }
        default:
            return state
    }
}
export default estateState
